// src/components/common/CGUModal.js
// Conditions Générales d'Utilisation — ANSSI EBIOSens Disclaimers
import React from 'react';
import { useTranslation } from 'react-i18next';
import { X, Scale } from 'lucide-react';

const CGUModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    const sections = [
        {
            title: t('cgu.disclaimer.title'),
            content: t('cgu.disclaimer.content')
        },
        {
            title: t('cgu.functionalEvaluation.title'),
            content: t('cgu.functionalEvaluation.content')
        },
        {
            title: t('cgu.labelNotCertification.title'),
            content: t('cgu.labelNotCertification.content')
        },
        {
            title: t('cgu.labelNotRobustness.title'),
            content: t('cgu.labelNotRobustness.content')
        },
        {
            title: t('cgu.homologation.title'),
            content: t('cgu.homologation.content')
        }
    ];

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={onClose}>
            <div
                className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[85vh] overflow-hidden flex flex-col"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="bg-gradient-to-r from-slate-800 to-slate-900 px-6 py-4 flex items-center justify-between flex-shrink-0">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center">
                            <Scale className="w-5 h-5 text-blue-400" />
                        </div>
                        <div>
                            <h2 className="text-lg font-bold text-white">
                                {t('cgu.title')}
                            </h2>
                            <p className="text-xs text-slate-400">
                                {t('cgu.subtitle')}
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 text-white transition-colors"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>

                {/* Content — scrollable */}
                <div className="overflow-y-auto flex-1 p-6 space-y-4">
                    {sections.map((section, idx) => (
                        <div
                            key={idx}
                            className="bg-gray-50 rounded-xl border border-gray-200 p-5 hover:shadow-md transition-shadow"
                        >
                            <h3 className="font-semibold text-gray-800 text-sm mb-3">
                                {idx + 1}. {section.title}
                            </h3>
                            <p className="text-gray-600 text-sm leading-relaxed">
                                {section.content}
                            </p>
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div className="border-t border-gray-200 px-6 py-3 bg-gray-50 flex justify-end flex-shrink-0">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg text-sm font-medium hover:from-blue-700 hover:to-indigo-700 transition-all shadow-sm"
                    >
                        {t('cgu.understood')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CGUModal;
